import styled from "styled-components";
import {
  TableRoot,
  Td,
  Th,
  ThGroup,
  Tr,
  TrOuter,
} from "../../../ui-kit/Table/styled";

export const OutcomeTable = styled.div`
  @media (max-width: 1169px) {
    ${TableRoot},
    ${ThGroup},
    ${Tr} {
      min-width: 0 !important;
      width: 100% !important;
    }

    ${TrOuter} {
      padding: 0 1.6rem;
    }

    ${ThGroup} {
      padding: 0 1.6rem 1.2rem;
    }

    ${Th},
    ${Td} {
      min-width: 0 !important;
      width: auto !important;
      flex: 1 1 auto !important;
    }

    ${Th}:first-child,
    ${Td}:first-child,
    ${Th}:last-child,
    ${Td}:last-child {
      flex: 0 0 auto !important;
      white-space: nowrap;
    }

    ${Th}:last-child,
    ${Td}:last-child {
      justify-content: flex-end;
      padding-right: 0;
    }
  }
`;
